import Image from 'components/Common/Image'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  overflow: hidden;
`

const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;

  background: linear-gradient(0deg, rgba(255, 255, 255, 0.60) 16.83%, rgba(155, 219, 249, 0.51) 65.38%, rgba(62, 185, 243, 0.36) 80%, rgba(67, 178, 172, 0.54) 99.04%);
`

interface Props {
  className?: string;
}

export function NeverEndingSummerBackground({ className }: Props) {
  const imageProps = {
    id: 'never-ending-summer-background-1',
    dpr: 2 as const,
    fit: 'center' as const,
  }
  return <Container className={className}>
    <Image {...imageProps} />
    <Gradient />
  </Container>
}
